/* eslint-disable */
import get from 'lodash/get'
import has from 'lodash/has'
import find from 'lodash/find'
import intl from 'react-intl-universal'

function Controller(
  $scope,
  $rootScope,
  $location,
  authorService,
  siteService,
  $timeout
) {
  this.intl = intl

  this.filterWebsite = () => {
    // update website sections
    siteService.getWebsite(this.config.websites.value).then((i) => {
      this.config.sections.filters = i.sections.map((i) => ({
        text: i.name,
        value: i.id,
      }))
    })
    this.runSearch()
  }

  this.filterSections = () => {
    // get location of Sites
    let index = this.config.leftFilters.findIndex(
      (i) => i.search === 'taxonomy.sections._id'
    )
    // mutate
    this.config.leftFilters[index].inputs[0].value = this.config.sections.value
    this.runSearch()
  }

  this.updateSearchTime = (time, input) => {
    input.value = time
    this.runSearch()
  }

  this.orgTimezone = $rootScope.globalSettings.timezone
  $rootScope.$on('SETTINGS_LOADED', (_, data) => {
    const { data: { timezone } = {} } = data || {}
    this.orgTimezone = timezone
  })

  $scope.stringify = function (obj) {
    return JSON.stringify(obj)
  }

  const _self = this

  /* I know this is the solution, trying to find a better way */
  $(window)
    .off('keydown.ac')
    .on('keydown.ac', (evt) => {
      var elem = $(evt.target)
      if (elem.is('[data-autocomplete]')) {
        elem
          .autocomplete({
            source: function (search, callback) {
              authorService.searchName(search.term).then((results) => {
                callback(results)
              })
            },
            select: function (event, ui) {
              // Mutates the input value directly
              // We should forego jqueryUI down the road
              const autocompleteService = get(
                event,
                'target.dataset.autocomplete'
              )
              const searchValue = get(ui, 'item.name')
              if (!has(_self, 'config.leftFilters')) {
                throw new Error('missing leftFilters')
              }
              for (let field of _self.config.leftFilters) {
                let input = find(
                  field.inputs,
                  (i) => i.autocomplete === autocompleteService
                )
                if (input) {
                  input.value = searchValue
                  _self.runSearch()
                  break
                }
              }
            },
          })
          .autocomplete('instance')._renderItem = function (ul, item) {
          ul.attr('data-testid', 'search-filter-autocomplete')
          const firstName = item.name.split(' ')[0] || 'unknown'

          return $(`<li data-testid=autocomplete-${firstName}>`)
            .append(`<div></div>`)
            .append(`<div>${item.name}</div>`)
            .appendTo(ul)
        }
      }
    })
}

export default [
  '$scope',
  '$rootScope',
  '$location',
  'authorService',
  'siteService',
  '$timeout',
  Controller,
]
